import {
  all,
  put,
  call,
  takeEvery,
  takeLatest,
  select
} from 'redux-saga/effects'
import { push } from 'connected-react-router'

import { getInteractions } from '../api'
import { apiError, showPopup } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout, LOGOUT } from './auth'
import { selectActiveState } from './states'
import { setLoadingScreenType } from './interactions'

const initialState = {
  entities: [],
  loading: false,
  error: null
}

export const moduleName = 'interactionsPreview'
export const FETCH_INTERACTIONS_PREVIEW_REQUEST = `${moduleName}/FETCH_INTERACTIONS_PREVIEW_REQUEST`
export const FETCH_INTERACTIONS_PREVIEW_SUCCESS = `${moduleName}/FETCH_INTERACTIONS_PREVIEW_SUCCESS`
export const FETCH_INTERACTIONS_PREVIEW_FAIL = `${moduleName}/FETCH_INTERACTIONS_PREVIEW_FAIL`
export const REDIRECT_TO_TICKET = `${moduleName}/REDIRECT_TO_TICKET`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_INTERACTIONS_PREVIEW_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_INTERACTIONS_PREVIEW_SUCCESS:
      return { ...state, loading: false, error: null, entities: payload }
    case FETCH_INTERACTIONS_PREVIEW_FAIL:
      return { ...state, loading: false, error: payload }
    case LOGOUT:
      return { ...initialState }

    default:
      return state
  }
}

export function fetchInteractionsPreview() {
  return {
    type: FETCH_INTERACTIONS_PREVIEW_REQUEST
  }
}

export function redirectToTicket(ticketId, state) {
  return {
    type: REDIRECT_TO_TICKET,
    payload: {
      ticketId,
      state
    }
  }
}

export const redirectToTicketSaga = function*({ payload }) {
  const { ticketId, state } = payload

  const stateId = state !== 'CLOSED' ? 0 : 2
  try {
    yield put(setLoadingScreenType(true))
    yield put(selectActiveState(stateId, false, false))
    yield put(push(`/dashboard/interactions/${ticketId}`))
  } catch (e) {
    console.error(e)
  }
}

export const fetchInteractionsPreviewSaga = function*() {
  try {
    // TODO get propertyId from common store
    const { selectedPropertyId } = yield select(({ properties }) => properties)
    const state = '-state:closed'
    const filterText = null
    const limit = 5
    const offset = 0

    const payload = yield call(
      getInteractions,
      selectedPropertyId,
      null,
      state,
      filterText,
      limit,
      offset
    )

    yield put({
      type: FETCH_INTERACTIONS_PREVIEW_SUCCESS,
      payload
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_INTERACTIONS_PREVIEW_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_INTERACTIONS_PREVIEW_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([
    takeEvery(FETCH_INTERACTIONS_PREVIEW_REQUEST, fetchInteractionsPreviewSaga),
    takeLatest(REDIRECT_TO_TICKET, redirectToTicketSaga)
  ])
}
